<template>
    <b-modal id="exact_to_shopware_manager_modal">
        <template slot="modal-title">Manage Exact Online to shopware config</template>
        <v-app class="v-appNoBackground v-app">
            <b-form ref="exact_to_shopware_manager_modal_form">

                <!--            <b-form-group label="test">-->
                <!--                <b-form-input-->
                <!--                        :state="data"-->
                <!--                        v-model="selected_url"-->
                <!--                        required>-->
                <!--                </b-form-input>-->
                <!--            </b-form-group>-->

            </b-form>
        </v-app>
        <template slot="modal-footer">
            <b-button block
                      variant="primary"
                      @click="save">
                Save config
                <v-icon dark>mdi-content-save-outline</v-icon>
            </b-button>
        </template>
    </b-modal>
</template>
<script>
    import ProjectRepository from '../../../repositories/project.repository'

    export default {
        props: {
            projectConfig: {
                type: Object,
                default: () => {
                }
            },
            projectId: {
                type: Number,
                default: -1
            }
        },
        data() {
            return {
                selected_url: '',
            }
        },
        methods: {
            save() {
                if (this.$refs.exact_to_shopware_manager_modal_form.checkValidity()) {
                    this.$emit('show-loading-pop-up', "Saving the project Config");
                    this.$bvModal.hide('exact_to_shopware_manager_modal');
                    ProjectRepository.saveProjectConfig(this.projectConfig, this.projectId).then(res => {
                        this.$emit('reset-loading-pop-up');
                        this.$emit('saved-project-config');
                        this.$bvToast.toast('Successfully saved the project config', {
                            title: `Config save successful.`,
                            variant: 'success',
                            solid: true
                        });
                    }).catch(error => {
                        this.$bvModal.show('exact_to_shopware_manager_modal');
                        console.error(error);
                        this.$bvToast.toast('Looks like something went wrong on the server while saving the project config.', {
                            title: `Config save error.`,
                            variant: 'danger',
                            solid: true
                        });
                    });
                }
            },
        }
    }
</script>
